import {
  /* URL_PATH_REGEX */
  getBrowserAndVersion,
} from '../helpers';
import {
  enumSchemaValidator,
  floatSchemaValidator,
  intSchemaValidator,
  mapSchemaValidator,
  // regexSchemaValidator,
  stringSchemaValidator,
} from './Validators';

export const EVENT_TYPE = {
  UNSPECIFIED: 'EVENT_TYPE_UNSPECIFIED',
  CLICK: 'EVENT_TYPE_CLICK',
  SHARE: 'EVENT_TYPE_SHARE',
  IMPRESSION: 'EVENT_TYPE_IMPRESSION',
  PAGE_LAUNCH: 'EVENT_TYPE_PAGE_LAUNCH',
  TYPING: 'EVENT_TYPE_TYPING',
  RECEIVE: 'EVENT_TYPE_RECEIVE',
};

export const FLOW_TYPE = {
  UNSPECIFIED: 'FLOW_TYPE_UNSPECIFIED',
  PPI: 'FLOW_TYPE_PPI',
  LIMIT: 'FLOW_TYPE_LIMIT',
  GIFT_CARD: 'FLOW_TYPE_GIFT_CARD',
};

export const { browserName, browserVersion } = getBrowserAndVersion();

export const ZFE_CORPORATE_DASHBOARD_TRACKING_KEYS = new Set([
  'id',
  'company_id',
  'flow_type',
  'browser_name',
  'browser_version',
  'web_version',
]);

export const WEB_SCHEMA_KEYS = new Set([
  'version',
  'browser_name',
  'browser_version',
  'url_segment',
  'ui_source',
  'event_type',
  'component',
  'meta_data',
]);

export const ZFE_API_SCHEMA_KEYS = new Set([
  'url_segment',
  'ui_source',
  'request_method',
  'request_domain',
  'request_path',
  'status_code',
  'custom_code',
  'response_time',
  'message',
]);

export const WebTrackingKeys = {
  version: {
    default: process.env.REACT_APP_RELEASE_VER ?? 'default',
    useDefaultAlways: true,
  },
  browser_name: { default: browserName, useDefaultAlways: true },
  browser_version: { default: String(browserVersion), useDefaultAlways: true },
  url_segment: {
    default: '',
    validators: [stringSchemaValidator],
  },
  ui_source: {
    default: '',
    validators: [stringSchemaValidator],
  },
  event_type: {
    default: EVENT_TYPE.UNSPECIFIED,
    validators: [enumSchemaValidator(EVENT_TYPE, 'event_type')],
  },
  component: {
    default: '',
    validators: [stringSchemaValidator],
  },
  meta_data: {
    default: {},
    validators: [
      mapSchemaValidator(stringSchemaValidator, stringSchemaValidator),
    ],
  },
};

export const ZfeApiTrackingKeys = {
  url_segment: {
    default: '',
    validators: [stringSchemaValidator],
  },
  ui_source: {
    default: '',
    validators: [stringSchemaValidator],
  },
  request_method: {
    default: '',
    validators: [stringSchemaValidator],
  },
  request_domain: {
    default: '',
    validators: [stringSchemaValidator],
  },
  request_path: {
    default: '',
    validators: [stringSchemaValidator],
  },
  status_code: {
    default: 0,
    validators: [intSchemaValidator],
  },
  custom_code: {
    default: 0,
    validators: [intSchemaValidator],
  },
  response_time: {
    default: 0,
    validators: [floatSchemaValidator],
  },
  message: {
    default: '',
    validators: [stringSchemaValidator],
  },
};

export const ZfeCorporateDashboardTrackingKeys = {
  id: {
    default: '',
    validators: [stringSchemaValidator],
  },
  company_id: {
    default: '',
    validators: [stringSchemaValidator],
  },
  flow_type: {
    default: FLOW_TYPE.UNSPECIFIED,
    validators: [enumSchemaValidator(FLOW_TYPE, 'flow_type')],
  },
  browser_name: { default: browserName, useDefaultAlways: true },
  browser_version: { default: String(browserVersion), useDefaultAlways: true },
  web_version: {
    default: '',
    validators: [stringSchemaValidator],
  },
  web_tracking: {
    recursive: true,
    trackKeys: WebTrackingKeys,
    keyName: 'web_tracking',
  },
  zfe_api_tracking: {
    recursive: true,
    trackKeys: ZfeApiTrackingKeys,
    keyName: 'zfe_api_tracking',
  },
};
